module Dashboard {
    "use strict";
    export var module = angular.module("frendsDashboard", ["frends-utils", "SharedEnvironmentsModule", "gridster", "ui.bootstrap", "n3-line-chart", "ui.select", "ngSanitize", "angular.filter"]);
}